module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('email-download-list-button', {
    staticClass: "mr-2"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/traffic/emails-without-finish"
    }
  }, [_vm._v("Cortes sin finalizar")]), _vm._v(" "), _c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#email",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Corte")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(email) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm._f("limit")(email.name)) + " - " + _vm._s(email.number))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.campaign_attribute.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.slug))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v(_vm._s(email.campaign_attribute.project_name))]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v(_vm._s(email.campaign_attribute.project_account_name) + " " + _vm._s(email.campaign_attribute.project_account_country_prefix))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(email.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_created_name,
          "src": user.avatar ? user.avatar : "/static/images/profile.png",
          "title": email.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_name,
          "src": user.avatar ? user.avatar : "/static/images/profile.png",
          "title": email.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v(_vm._s(email.state_name) + _vm._s(email.hours ? (" - " + (email.hours) + " hs") : ''))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: email.time
    }, [_vm._v(_vm._s(email.date))])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "cursor-pointer flex items-center mr-3",
      attrs: {
        "to": '/admin/traffic/email/' + email.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "email"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.name),
      expression: "email.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.number),
      expression: "email.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.date),
      expression: "email.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.project_id),
      expression: "email.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.campaign_id),
      expression: "email.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                    " + _vm._s(campaign.name) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.path),
      expression: "email.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "path", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Crear Corte\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4013b248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/ListEmail.vue
// module id = 434
// module chunks = 1